export default __webpack_public_path__ + "static/nbox-5c04f971bb3b417cbfb36920e11ff5ed.jpg";